import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { MessageService } from 'primeng/api';
import { AppMenuProfile } from './app.menuprofile';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule, AppMenuProfile],
    template: `<ul class="layout-menu">
        <div app-menu-profile></div>
        @for (item of menu; track $index) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [root]="true"></li>
            } @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `
})
export class AppMenu {
    menu: any[] = [
        {
            label: 'Dashboard',
            icon: "pi pi-chart-bar",
            path: '/home',
            items: [
                {
                    icon: 'pi pi-inbox',
                    label: 'Dashboard',
                    path: '/home/dashboards',
                    items: [
                        {
                            icon: "pi pi-home",
                            label: "Home",
                            routerLink: ['/cadastros/clientes']
                        }
                    ],
                }
            ],
        },
        {
            separator: true,
        },
        {
            label: 'Terminal',
            icon: "pi pi-truck",
            path: '/terminal',
            items: [
                {
                    icon: 'pi pi-inbox',
                    label: 'Terminal',
                    path: '/terminal/logistica',
                    items: [
                        {
                            icon: "pi pi-inbox",
                            label: "Consulta Estoque",
                            path: '/terminal',
                            items: [
                                {
                                    icon: "pi pi-truck",
                                    label: "Containers",
                                    routerLink: ['/terminal/consulta-estoque/containers'],
                                },
                                {
                                    icon: "pi pi-box",
                                    label: "Produtos",
                                    routerLink: ['/terminal/consulta-estoque/produtos'],
                                }
                            ]
                        },
                        {
                            icon: "pi pi-th-large",
                            label: "Monitoramento Container",
                            routerLink: ['/terminal/monitoramento-container']
                        },
                        {
                            icon: "pi pi-calendar-clock",
                            label: "Programação Container",
                            routerLink: ['/terminal/programacao-container']
                        },
                        // {
                    //     icon: "pi pi-credit-card",
                        //     label: "Faturamento",
                        //     routerLink: ['/terminal/faturamento']
                        // },
                        {
                            icon: "pi pi-calendar-clock",
                            label: "Agendamentos",
                            routerLink: ['/terminal/agendamentos']
                        },
                        {
                            icon: "pi pi-history",
                            label: "Histórico Checklists",
                            routerLink: ['/terminal/checklists/historico']
                        },
                    ],
                }
            ],
        },
        {
            separator: true,
        },
        {
            label: 'Frete',
            icon: "pi pi-globe",
            path: '/frete',
            items: [
                {
                    icon: 'pi pi-globe',
                    label: 'Frete',
                    path: '/frete/logistica',
                    items: [
                        {
                            icon: "pi pi-wifi",
                            label: "Fretes Online",
                            routerLink: ['/frete/frete-online']
                        },
                        {
                            icon: "pi pi-wallet",
                            label: "Extrato Financeiro",
                            routerLink: ['/frete/extrato-financeiro']
                        },
                    ],
                }
            ],
        },
    ];

    constructor(
        private _authService: AuthService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
    }
}
